import { Pipe, PipeTransform } from '@angular/core';
import { difference, uniqBy } from 'lodash';

import { Experience } from '@hiptraveler/data-access/api';

@Pipe({
  name: 'mergeExperiences',
  pure: true,
})
export class MergeExperiencesPipe implements PipeTransform {

  transform(experiences: Partial<Experience>[], subCategories: string[]): Partial<Experience>[] {

    const filteredExperiences = (experiences ?? []).filter(
      (e) => e.category === 'activity'
    );

    const experienceCodes = filteredExperiences.map((exp) => exp.code).filter(Boolean);
    const filteredCategories = difference(subCategories, experienceCodes);

    return uniqBy(filteredExperiences.concat(
      filteredCategories.map((category) => ({
        name: category,
        code: category,
      }))
    ), 'code');
  }

}
